import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_BASE_URL } from "../config";
import { setError } from "./errorSlice";

/**
 * Async thunk to generate transcript for a student by ID.
 * Makes a POST request to /api/Transcript/GenerateTranscript/{studentId}
 */
export const generateTranscript = createAsyncThunk(
  "transcript/generateTranscript",
  async (studentId, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        const msg = "Session expired. Please log in again.";
        dispatch(setError(msg));
        return rejectWithValue(msg);
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        const msg = "Session expired. Please log in again.";
        dispatch(setError(msg));
        return rejectWithValue(msg);
      }

      const response = await fetch(
        `${API_BASE_URL}/api/Transcript/GenerateTranscript/${studentId}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to generate transcript");
      }

      // Assuming the API returns JSON data representing the transcript
      return await response.json();
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);


export const fetchTranscriptByStudentId = createAsyncThunk(
  "transcript/fetchTranscriptByStudentId",
  async (studentId, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        const msg = "Session expired. Please log in again.";
        dispatch(setError(msg));
        return rejectWithValue(msg);
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        const msg = "Session expired. Please log in again.";
        dispatch(setError(msg));
        return rejectWithValue(msg);
      }

      const response = await fetch(
        `${API_BASE_URL}/api/Transcript/Student/${studentId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch transcript");
      }

      return await response.json(); // returns array of academic years with transcript objects
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);

const transcriptSlice = createSlice({
  name: "transcript",
  initialState: {
    data: null,
    loading: false,
    error: null,
      fetchedTranscript: null,
  },
  reducers: {
    clearTranscript(state) {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
     
    
    .addCase(fetchTranscriptByStudentId.pending, (state) => {
    state.loading = true;
    state.error = null;
  })
  .addCase(fetchTranscriptByStudentId.fulfilled, (state, action) => {
    state.loading = false;
    state.fetchedTranscript = action.payload;
  })
  .addCase(fetchTranscriptByStudentId.rejected, (state, action) => {
    state.loading = false;
    state.error = action.payload;
  })
  // Generate transcript
      .addCase(generateTranscript.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(generateTranscript.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(generateTranscript.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearTranscript } = transcriptSlice.actions;
export default transcriptSlice.reducer;
